import { useAppContext } from '../../../../Services/AppContext';
import SearchWorkplaceMemberNoResults from './SearchWorkplaceMemberNoResults';
import SearchWorkplaceMemberResult from './SearchWorkplaceMemberResult';
import { useState } from 'react';
import { useEffectAsync } from '../../../../helpers';
import apiClient from '../../../../Services/ApiClient';
import { gql } from '@apollo/client';
import * as React from 'react';
import Search from '../../../BaseModule/Components/Search/Search';
import {
	AVATAR_FRAGMENT,
	PROFILE_NAME_FRAGMENT,
} from '../../../User/Components/UserInfo/UserData';

export default function SearchWorkplaceMember({
	linkSelect,
	gqlParams = {},
	hideFavoriteButton = false,
	hideEmptySearch = false,
	workplaceFromElement = null,
	patientId,
}) {
	const { translation } = useAppContext();
	const [items, setItems] = useState(null);
	const [fulltext, setFulltext] = useState('');

	const searchQuery = gql`
		${PROFILE_NAME_FRAGMENT}
		${AVATAR_FRAGMENT}
		query Doctors($fulltext: String!, $workplaceId: UUID) {
			caseDoctors(fulltext: $fulltext, workplaceId: $workplaceId) {
				data {
					id
					workplace {
						id
						caseDoctorDescription
						address {
							fullAddress
						}
					}
					user {
						id
						...avatar
						profile {
							...userName
						}
					}
				}
			}
		}
	`;

	const handleSearch = text => {
		setFulltext(text);
	};

	const variables = { fulltext, ...gqlParams };

	// @ts-ignore
	useEffectAsync(async () => {
		if (!hideEmptySearch || fulltext.length > 2) {
			if (workplaceFromElement) {
				const selectedWorkplace =
					document.getElementById(workplaceFromElement).value;
				if (selectedWorkplace) {
					variables.workplaceId = selectedWorkplace;
				}
			}
			const result = await apiClient.graphql({
				query: searchQuery,
				variables: variables,
				fetchPolicy: 'network-only',
			});
			setItems(result?.data?.caseDoctors?.data || []);
		} else {
			setItems(null);
		}
	}, [fulltext, workplaceFromElement]);

	const itemsContent = items?.length ? (
		items.map((item, index) => (
			<SearchWorkplaceMemberResult
				key={item.id}
				workplaceMember={item}
				linkSelect={linkSelect}
				hideFavoriteButton={hideFavoriteButton}
				patientId={patientId}
			/>
		))
	) : (
		<SearchWorkplaceMemberNoResults />
	);

	return (
		<Search
			resultContent={items !== null ? itemsContent : null}
			handleSearch={handleSearch}
			placeholder={
				translation['base.shared.enterSurnameOfDoctorWhichYouAreLookingFor']
			}
		/>
	);
}
